// Ranking GLOBAL con Cloud Firestore. Cada jugador guarda su MEJOR puntuación en el
// documento `leaderboard/{uid}` (uid de su cuenta de Google); el ranking se lee de ahí.
// Versión "lite" de Firestore: solo lecturas/escrituras puntuales (sin listeners en tiempo
// real), mucho más ligera en el bundle. Suficiente para el ranking.
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  collection,
  query,
  orderBy,
  limit as fbLimit,
  getDocs,
} from 'firebase/firestore/lite';

export class RankingService {
  constructor(app) {
    this.db = getFirestore(app);
  }

  /** Sube TU mejor puntuación (solo si mejora la guardada). `avatar` = emoji o URL de foto. */
  async submitBest({ uid, name, avatar, score }) {
    if (!uid || typeof score !== 'number' || !isFinite(score)) return false;
    const ref = doc(this.db, 'leaderboard', uid);
    try {
      const snap = await getDoc(ref);
      const prev = snap.exists() ? (snap.data().score || 0) : -Infinity;
      if (Math.round(score) <= prev) return false; // solo guarda récords
      await setDoc(ref, {
        name: String(name || 'Jugador').slice(0, 24),
        avatar: String(avatar || '🙂').slice(0, 512),
        score: Math.round(score),
        updatedAt: Date.now(),
      });
      return true;
    } catch (e) {
      console.warn('[Ranking] no se pudo subir la puntuación', e);
      return false;
    }
  }

  /** Borra TU entrada del ranking global (al reiniciar el juego). Mejor esfuerzo. */
  async remove(uid) {
    if (!uid) return;
    try {
      await deleteDoc(doc(this.db, 'leaderboard', uid));
    } catch (e) {
      console.warn('[Ranking] no se pudo borrar la entrada', e);
    }
  }

  /** Lee el top N ordenado por puntuación (desc). Lanza si no hay conexión / Firestore. */
  async fetchTop(n = 100) {
    const q = query(collection(this.db, 'leaderboard'), orderBy('score', 'desc'), fbLimit(n));
    const snap = await getDocs(q);
    const rows = [];
    snap.forEach((d) => rows.push({ uid: d.id, ...d.data() }));
    return rows;
  }
}
